import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SubcontractingJobQueueView } from "src/components/views/erp/production/subcontracting/SubcontractingJobQueueView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/production/subcontractingJobQueue")({
	staticData: { title: i18n.t("subcontracting_job_queue"), legacyViewKey: "subcontractingJobQueuePage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <SubcontractingJobQueueView isActive={isActive} />;
}
